import { FC } from "react";

import ProductImage from "./product-image";

import Stars from "@components/icons/stars";
import VerifiedIcon from "@components/icons/verified-icon";
import { formatDate } from "@utils/datetime";
import { ReviewWithProduct } from "@interfaces/review";

type Props = ReviewWithProduct;

const ProductReviewCard: FC<Props> = ({
  product,
  date,
  text,
  author,
  rating,
  verified,
}) => (
  <div className="flex flex-row space-x-4 p-4 bg-white w-full rounded-md ring-black ring-2 text-sm">
    <div className="w-1/3">
      <ProductImage
        {...{
          name: product.cardName,
          slug: product.slug,
          photo: product.featuredPhoto,
          highlightPhoto: product.featuredPhotoHighlight,
          productId: product.id,
          withLikeButton: false,
        }}
      />
    </div>
    <div className="w-2/3 space-y-2">
      <div className="font-bold">{product.cardName}</div>
      <div className="flex flex-row items-center space-x-4">
        <Stars {...{ rating }} />
        <span>{formatDate(date, "DD/MM/YYYY")}</span>
      </div>
      <div>
        <p className="overflow-hidden line-clamp-2 leading-6">{text}</p>
      </div>
      <div className="text-xs text-gray-700 text-opacity-50">
        Recenzija napravljena na Renya Home
      </div>
      <div className="flex flex-row items-center justify-items-start space-x-2 text-xs">
        <span>{author} ·</span>
        {verified && (
          <>
            <VerifiedIcon size={18} />
            <span>Verifikovani klijent</span>
          </>
        )}
      </div>
    </div>
  </div>
);

export default ProductReviewCard;
